import React from "react"
import RegisterGoogleDetail from "../../../common/GoogleOriginalDesign/Foodslabo/Detail/RegisterGoogleDetail"

export default function GoogleRegisterSendai() {
    return (
        <RegisterGoogleDetail
            reasonPoint1Images={[
                {
                    src: "/pages/google/foodslabo/register_sendai/reason_point1_img1.png",
                    alt: "仙台の限定求人詳細1枚目",
                },
                {
                    src: "/pages/google/foodslabo/register_sendai/reason_point1_img2.png",
                    alt: "仙台の限定求人詳細2枚目",
                },
                {
                    src: "/pages/google/foodslabo/register_sendai/reason_point1_img3.png",
                    alt: "仙台の限定求人詳細3枚目",
                },
            ]}
        />
    )
}
